import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { isNumber } from 'lodash/fp';
import * as styles from './Truncate.css';

const cx = classnames.bind(styles);

export function Truncate({
    testId = null,
    className = null,
    children,
    maxWidth = null,
    lines = null,
    block = false,
    ...props
}) {
    const classes = cx('base', { lineClamp: isNumber(lines), block }, className);
    const inlineStyles = { maxWidth, WebkitLineClamp: lines };

    return (
        <span data-testid={testId} className={classes} style={inlineStyles} {...props}>
            {children}
        </span>
    );
}

Truncate.propTypes = {
    /**
     * Emit a `data-testid` prop on the root element of the component. Use this
     * to help automated testing tools find this particular component.
     */
    testId: PropTypes.string,

    /**
     * Set additional CSS classes on the component to extend the default styles.
     */
    className: PropTypes.string,

    /**
     * Set the maximum width of the element at which point it gets truncated
     */
    maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /**
     * If set, the experimental `line-clamp` style is applied with the value provided.
     */
    lines: PropTypes.number,

    /**
     * If set adds `display: block` style
     **/
    block: PropTypes.bool
};
